import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSuiteAppearance } from "@fg/ui-theme";
import { App } from "./App";
import { oidcConfig } from "@/auth/authConfig";

import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false
        }
    }
});

const rootEl = document.getElementById("root");
if (!rootEl) {
    throw new Error("Root element #root not found in index.html");
}

// Belt-and-suspenders — the side-effect import above already registered
// the .env.local key, but this gives us a hook for a backend-fetched
// override in prod without rewiring callers. Same pattern mail-web uses.

// Suite look (mode, accent, top bar) — the pre-paint script in index.html
// already applied it; this starts the live store before React mounts.
initSuiteAppearance("pdf");

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </AuthProvider>
    </React.StrictMode>
);
